import { render, staticRenderFns } from "./Parameters.vue?vue&type=template&id=c24466bc&scoped=true&"
import script from "./Parameters.vue?vue&type=script&lang=ts&"
export * from "./Parameters.vue?vue&type=script&lang=ts&"
import style0 from "./Parameters.vue?vue&type=style&index=0&id=c24466bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24466bc",
  null
  
)

export default component.exports